<template>
  <div>
    <div class="images-toolbar">
      <div class="tag-summary">
        <span class="tag-summary__label">Image tags</span>
        <template v-for="attribute in imageAttributes">
          <span v-if="locationImageAttributesCount[attribute.id]" :key="attribute.id" class="tag-summary__tag">
            {{ attribute.title }} <b>{{ locationImageAttributesCount[attribute.id] }}</b>
          </span>
        </template>
      </div>
      <el-button type="danger" plain size="small" icon="el-icon-delete" @click="deleteAll()">Delete All</el-button>
    </div>

    <p class="help-text">Drag images to change their order. The order saves straight away.</p>

    <draggable v-model="images" class="image-grid" @start="drag=true" @end="drag=false">
      <div v-for="(image, index) in images" :key="image._id" class="image-card">
        <div class="image-card__badges">
          <span v-if="image.primary == true" class="image-badge image-badge--primary">Primary</span>
          <span v-if="image.attributes.length" class="image-badge">Tagged</span>
        </div>
        <el-tooltip v-if="image.attributes.length" placement="top">
          <!-- The tag list loads separately (and a tag may have been deleted), so skip unknown ones. -->
          <div v-for="attribute in image.attributes.filter(id => imageAttributesMap[id])" :key="attribute" slot="content">{{imageAttributesMap[attribute].title}}<br/></div>
          <img :src="$imgix(image.filename, 500)" class="image" @click="editImage(image)">
        </el-tooltip>
        <img v-else :src="$imgix(image.filename, 500)" class="image" @click="editImage(image)">

        <div class="image-card__footer">
          <span class="order">Order {{ index + 1 }}</span>
          <span>
            <el-button icon="el-icon-edit" size="mini" @click="editImage(image)" circle title="Edit tags"></el-button>
            <el-button type="danger" plain icon="el-icon-delete" size="mini" @click="deleteImage(image._id)"
                       circle title="Delete image"></el-button>
          </span>
        </div>
      </div>
    </draggable>

    <el-drawer
      size="70%"
      title="Edit image"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose">

      <div class="image-editor">
        <div class="image-editor__preview">
          <el-image :src="$imgix(activeImage.filename, 800)" fit="contain" class="image-editor__image"></el-image>
          <el-button v-if="activeImage.primary !== true" type="success" plain icon="el-icon-star-off"
                     @click="makePrimaryImage(activeImage)">Make Primary</el-button>
          <el-button v-else type="danger" plain @click="removePrimaryImage(activeImage)">Remove As Primary</el-button>
        </div>

        <el-form ref="form" :model="form" label-position="top" class="image-editor__tags">
          <el-form-item label="Tags" prop="type">
            <el-checkbox-group v-model="form.attributes" class="image-checkbox-group">
              <el-checkbox v-for="item in imageAttributes" :label="item.id" :key="item.id">{{ item.title }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <div class="form-actions">
            <el-button type="primary" @click="onSubmit">Save</el-button>
          </div>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  export default {
    props: ['location'],
    name: "LocationImages",
    data() {
      return {
        images: [],
        imagesReadyToSubmit: false,
        drawer: false,
        direction: 'rtl',
        activeImage: '',
        fit: 'contain',

        form: {
          attributes: []
        },

        imageAttributes: [],
        imageAttributesMap: {},

        locationImageAttributesCount: {},

        primaryImage: undefined

      }
    },

    methods: {

      makePrimaryImage(image) {
        // If no primary image then set it
        if(this.primaryImage == undefined) {
          image.primary = true;
          this.onSubmit();
        }
        // Else if primary say it will unset it.
        else {

          this.$confirm('A primary image already exists. Replace?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(async () => {

            this.primaryImage.primary = false;

            // First we save primary image as no longer being primary
            await this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}/images/${this.primaryImage._id}`,
                    {
                      primary: this.primaryImage.primary
                    },
                    {
                      headers: {
                        Authorization: localStorage.getItem('Authorization')
                      }
                    });

            image.primary = true;
            this.primaryImage = image;

            // Now we can call on submit because it is the active image
            this.onSubmit();


          }).catch(() => {

          });


        }
      },

      removePrimaryImage(image) {
        image.primary = false;
        this.primaryImage = undefined;
        this.onSubmit();
      },

      // Saving the image editing
      onSubmit() {
        // Remove primary if another image is primary

        this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}/images/${this.activeImage._id}`,
          {
            attributes: this.form.attributes,
            primary: this.activeImage.primary
          },
          {
            headers: {
              Authorization: localStorage.getItem('Authorization')
            }
          })
          .then(response => {

            console.log(response.data);

            this.$notify({
              title: 'Success',
              message: 'Tags Saved.',
              type: 'success'
            });

            this.drawer = false;

            this.getImages();


          })
          .catch(error => {
            console.log(error);

          });

      },

      handleClose(done) {
        // Delete form attributes for the next one.
        this.form.attributes = [];
        done();
      },

      editImage(image) {

        this.activeImage = image;
        this.form.attributes = image.attributes;
        this.drawer = true;


      },

      deleteAll() {

        this.$confirm('This will permanently delete all images. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(async () => {

          for(let i = 0; i < this.images.length; i++){

           await this.axios.delete(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}/images/${this.images[i]._id}`,
                    {
                      headers: {
                        Authorization: localStorage.getItem('Authorization')
                      }
                    });

          }

          this.images = [];

          this.$notify({
            title: 'Success',
            message: 'All Images Removed.',
            type: 'success'
          });

        }).catch(err => {

          this.$notify.error({
            title: 'Error',
            message: err
          });

        });

      },

      deleteImage(imageID) {

        this.$confirm('This will permanently delete the image. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {


          this.axios.delete(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}/images/${imageID}`,
            {
              headers: {
                Authorization: localStorage.getItem('Authorization')
              }
            })
            .then(result => {
              console.log(result);

              for (var i = 0; i < this.images.length; i++) {
                if (this.images[i]._id == imageID) {
                  this.images.splice(i, 1);
                }
              }

              this.$notify({
                title: 'Success',
                message: 'Image Removed.',
                type: 'success'
              });


            })
            .catch(err => {
              this.$notify.error({
                title: 'Error',
                message: err
              });
            });


        }).catch(() => {

        });
      },

      getImages() {
        //ensures watcher doesnt upload images whilst changing to empty array
        this.imagesReadyToSubmit = false;
        // Reset it to empty array
        this.images = [];

        this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}/images`, {
          headers: {
            Authorization: localStorage.getItem('Authorization')
          }
        })
          .then(response => {

            // Reset the count object
            this.locationImageAttributesCount = {};

            // Get all image attributes
            response.data.forEach(image => {

              // If image is primary then set it as primary
              if(image.primary == true) {
                this.primaryImage = image;
              }

              image.attributes.forEach(attribute => {
                console.log(attribute);
                if(this.locationImageAttributesCount[attribute]){
                  this.locationImageAttributesCount[attribute] ++;
                } else {
                  this.locationImageAttributesCount[attribute] = 1;
                }
              });
            });

            let unorderedImages = [];
            let imagesWithOrders = [];

            for (let i = 0; i < response.data.length; i++) {

              // We need to reset the order in case an image was deleted from the upload page and there are missing orders.
              // If image has order, add to ordered images
              if (response.data[i].order) {

                imagesWithOrders.push(response.data[i]);

              } else if (!response.data[i].order) {

                unorderedImages.push(response.data[i]);

              }

            }

            //Sort the images with order

            imagesWithOrders.sort(function (a, b) {
              return a.order > b.order ? 0 : -1;
            });

            //Add ordered images

            for (let i = 0; i < imagesWithOrders.length; i++) {
              this.images.push(imagesWithOrders[i]);
            }

            // Add images without order
            for (let i = 0; i < unorderedImages.length; i++) {
              this.images.push(unorderedImages[i]);
            }

            this.imagesReadyToSubmit = true;


          })
          .catch(error => {
            console.log(error);
          });


      }
    },

    beforeMount() {

      //    Get all the images associated with the location
      this.getImages();


      //  Get all the image attributes
      this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/attributes`, {
        headers: {
          Authorization: localStorage.getItem('Authorization')
        }
      })
        .then(response => {

          response.data.forEach((item, index) => {


            if (item.type == 'Image Tags') {

              this.imageAttributes.push({id: item._id, title: item.title, type: item.type});
              // $set, so tooltips waiting for this tag's name re-render once it loads.
              this.$set(this.imageAttributesMap, item._id, {id: item._id, title: item.title, type: item.type});


            }

            //  Sort them alphabetically
            this.imageAttributes.sort(function (a, b) {
              return a.title > b.title ? 0 : -1;
            });

          });

        })
        .catch(error => {
          console.log(error);

        });

    },

    watch: {
      // We watch images to check if the order has changed.
      images: function (images) {

        if (this.imagesReadyToSubmit) {
          this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.location._id}/images`,
            {
              images: this.images,
            },
            {
              headers: {
                Authorization: localStorage.getItem('Authorization')
              }
            })
            .then(response => {
              console.log(response.data);
            })
            .catch(error => {
              console.log(error);

            });
        }


      }
    }
  }
</script>

<style scoped>
  .images-toolbar {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 8px;
  }

  .tag-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }

  .tag-summary__label {
    margin-right: 4px;
    font-weight: 600;
  }

  .tag-summary__tag {
    padding: 2px 10px;
    border-radius: 12px;
    background: var(--page-bg);
    font-size: 12px;
  }

  .tag-summary__tag b {
    color: var(--lav-green-dark);
  }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 16px;
  }

  .image-card {
    position: relative;
    overflow: hidden;
    border: 1px solid var(--border);
    border-radius: 10px;
    background: #fff;
    cursor: grab;
  }

  .image {
    display: block;
    width: 100%;
    height: 160px;
    object-fit: cover;
    cursor: pointer;
  }

  .image-card__badges {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
    display: flex;
    gap: 6px;
  }

  .image-badge {
    padding: 2px 8px;
    border-radius: 10px;
    background-color: #E6A23D;
    color: white;
    font-size: 12px;
    font-weight: 600;
  }

  .image-badge--primary {
    background-color: var(--lav-green-dark);
  }

  .image-card__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
  }

  .order {
    font-size: 13px;
    color: var(--text-muted);
  }

  /* The drawer: the image on the left, its tags on the right. */
  .image-editor {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
  }

  .image-editor__preview {
    flex: 1 1 360px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .image-editor__image {
    width: 100%;
    height: 60vh;
    border-radius: 10px;
    background: var(--page-bg);
  }

  .image-editor__tags {
    flex: 1 1 320px;
  }

  .image-checkbox-group {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 4px 16px;
  }

  .image-checkbox-group .el-checkbox {
    margin-right: 0;
    line-height: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/locations/LocationImages.vue